import { RoomTypes } from '@weblite/ts-action/room'
import { closeCurrentModal } from 'weblite-web-modal-viewer'
import { BottomDrawer } from '$common/bottom-drawer'
import { useIsDesktopSize } from '$common/react-hooks/layout'
import { SettingsSection } from '$common/settings-section'
import { t } from '$i18n'
import { ToolBoxHeaderIcon } from '$common/icons/tool-box-header-icon'
import { styled } from '@mui/material'
import { breakpoints } from '$setup/breakpoints'
import { ToolboxWapp } from './types'
import { ToolBoxWappItemButton } from './tool-box-wapp-item-button'

interface Props {
  isOpen?: boolean
  wapps: ToolboxWapp[]
}
export function ChatToolboxModal({ isOpen = false, wapps }: Props) {
  const isDesktop = useIsDesktopSize()

  return (
    <BottomDrawer
      isTransparent
      isOpen={isOpen}
      onClose={closeCurrentModal}
      bottomSafeAreaColor="veryLightGray"
      paperProps={{
        sx: isDesktop
          ? {
              margin: 'unset',
              right: 0,
              maxWidth: 360,
            }
          : null,
      }}
    >
      <SettingsSection
        headerText={t('chatList.tabs.wappRoom')}
        sx={{ marginBottom: 0 }}
        headerIcon={
          <ToolBoxHeaderIcon sx={{ width: '100%', height: '100%' }} />
        }
      >
        <WappContainer>
          {wapps.map(
            ({ icon, name, onClick, disabled, badge, loadingGradient }) => (
              <ToolBoxWappItemButton
                key={name}
                icon={icon}
                text={name}
                onClick={() => {
                  closeCurrentModal()

                  // TODO[router]: Fix by onRouterTransitionEnd
                  setTimeout(() => onClick(), 250)
                }}
                disabled={disabled}
                badge={badge}
                gradiant={loadingGradient}
              />
            ),
          )}
        </WappContainer>
      </SettingsSection>
    </BottomDrawer>
  )
}

const WappContainer = styled('div')({
  width: '100%',
  margin: 'auto',
  position: 'relative',
  padding: '16px',
  display: 'grid',

  gridTemplateColumns: '1fr 1fr 1fr',
  gridColumnGap: '20px',
  gridRowGap: '26px',
  [breakpoints.up(20.625)]: {
    gridTemplateColumns: '1fr 1fr 1fr 1fr',
    gridColumnGap: '12px',
    gridRowGap: '26px',
  },
  [breakpoints.up(23.125)]: {
    gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr',
    gridColumnGap: '0',
    gridRowGap: '26px',
  },
})
